export const OverPassAbsoluteURL = "https://overpass-api.de/api/interpreter";
export const SearchAddressURL = "https://nominatim.openstreetmap.org/search";
export const ORMAbsoluteURL = "https://routing.openstreetmap.de/";

